import { useState } from "react";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

const ADIMLAR = [
  { no: 1, baslik: "Kampanya Amacı", ikon: "ri-focus-3-line" },
  { no: 2, baslik: "Kampanya Seç", ikon: "ri-layout-grid-line" },
  { no: 3, baslik: "Reklam Türü", ikon: "ri-advertisement-line" },
  { no: 4, baslik: "Bütçe", ikon: "ri-money-dollar-circle-line" },
  { no: 5, baslik: "Hedef Bölge", ikon: "ri-map-pin-2-line" },
  { no: 6, baslik: "Onayla", ikon: "ri-checkbox-circle-line" },
];

const AMACLAR = [
  { id: "mesaj", baslik: "Daha Fazla Mesaj Al", aciklama: "WhatsApp ve DM üzerinden daha fazla potansiyel müşteri çek", ikon: "ri-message-3-line", renk: "from-emerald-500 to-teal-600", accent: "#10b981" },
  { id: "randevu", baslik: "Daha Fazla Randevu Al", aciklama: "Online randevu formuna daha fazla kişiyi yönlendir", ikon: "ri-calendar-check-line", renk: "from-violet-500 to-purple-600", accent: "#7c3aed" },
  { id: "tanitim", baslik: "Kampanyanı Tanıt", aciklama: "Mevcut kampanyanı geniş kitlelere duyur ve marka bilinirliğini artır", ikon: "ri-megaphone-line", renk: "from-amber-500 to-orange-600", accent: "#f59e0b" },
  { id: "satis", baslik: "Satışlarını Artır", aciklama: "Doğrudan satış odaklı reklam ile gelirini büyüt", ikon: "ri-line-chart-line", renk: "from-rose-500 to-pink-600", accent: "#ec4899" },
];

const KAMPANYALAR = [
  { id: "cilt", ad: "Cilt Bakımı Kampanyası", aciklama: "Profesyonel cilt bakımı ve gençleştirme uygulamaları", gorsel: "https://readdy.ai/api/search-image?query=professional%20skin%20care%20treatment%20clinic%20clean%20white%20background%20beauty%20spa%20facial%20treatment%20elegant%20minimalist%20product%20photography&width=400&height=240&seq=camp1&orientation=landscape", etiket: "Popüler", etiketRenk: { bg: "rgba(16,185,129,0.15)", color: "#10b981" } },
  { id: "lazer", ad: "Lazer Epilasyon", aciklama: "Kalıcı lazer epilasyon paketleri ve özel fırsatlar", gorsel: "https://readdy.ai/api/search-image?query=laser%20hair%20removal%20treatment%20modern%20clinic%20professional%20equipment%20clean%20white%20background%20medical%20beauty%20technology&width=400&height=240&seq=camp2&orientation=landscape", etiket: "Çok Tercih Edilen", etiketRenk: { bg: "rgba(124,58,237,0.15)", color: "#a78bfa" } },
  { id: "dudak", ad: "Dudak Renklendirme", aciklama: "Kalıcı dudak renklendirme ve dolgu uygulamaları", gorsel: "https://readdy.ai/api/search-image?query=lip%20treatment%20beauty%20clinic%20professional%20cosmetic%20procedure%20elegant%20close%20up%20soft%20lighting%20clean%20background&width=400&height=240&seq=camp3&orientation=landscape", etiket: "Yeni", etiketRenk: { bg: "rgba(236,72,153,0.15)", color: "#ec4899" } },
  { id: "g5", ad: "G5 Sıkılaşma", aciklama: "G5 masaj cihazı ile vücut sıkılaştırma ve selülit tedavisi", gorsel: "https://readdy.ai/api/search-image?query=body%20slimming%20treatment%20massage%20device%20beauty%20spa%20professional%20clinic%20clean%20white%20background%20wellness%20technology&width=400&height=240&seq=camp4&orientation=landscape", etiket: "Fırsat", etiketRenk: { bg: "rgba(245,158,11,0.15)", color: "#f59e0b" } },
];

const REKLAM_TURLERI = [
  { id: "whatsapp", baslik: "WhatsApp Mesaj Kampanyası", aciklama: "Kullanıcıları doğrudan WhatsApp'a yönlendir", ikon: "ri-whatsapp-line", accent: "#22c55e", bg: "rgba(34,197,94,0.1)", border: "rgba(34,197,94,0.3)", etiket: "En Etkili" },
  { id: "instagram-form", baslik: "Instagram Form Kampanyası", aciklama: "Instagram üzerinden lead form ile müşteri bilgisi topla", ikon: "ri-instagram-line", accent: "#ec4899", bg: "rgba(236,72,153,0.1)", border: "rgba(236,72,153,0.3)", etiket: "Önerilen" },
  { id: "gorsel", baslik: "Görsel Reklam", aciklama: "Dikkat çekici görseller ile marka bilinirliğini artır", ikon: "ri-image-2-line", accent: "#f59e0b", bg: "rgba(245,158,11,0.1)", border: "rgba(245,158,11,0.3)", etiket: null },
  { id: "video", baslik: "Video Reklam", aciklama: "Kısa ve etkili video içerikleri ile daha fazla etkileşim al", ikon: "ri-video-line", accent: "#a78bfa", bg: "rgba(124,58,237,0.1)", border: "rgba(124,58,237,0.3)", etiket: null },
];

const BUTCELER = [
  { id: "3000", label: "3.000 TL", aciklama: "Başlangıç paketi", ikon: "ri-seedling-line", accent: "#10b981", bg: "rgba(16,185,129,0.1)", border: "rgba(16,185,129,0.3)" },
  { id: "5000", label: "5.000 TL", aciklama: "Standart paket", ikon: "ri-bar-chart-line", accent: "#f59e0b", bg: "rgba(245,158,11,0.1)", border: "rgba(245,158,11,0.3)" },
  { id: "10000", label: "10.000 TL", aciklama: "Premium paket", ikon: "ri-rocket-line", accent: "#a78bfa", bg: "rgba(124,58,237,0.1)", border: "rgba(124,58,237,0.3)" },
  { id: "ozel", label: "Özel Bütçe Gir", aciklama: "Kendi bütçeni belirle", ikon: "ri-edit-line", accent: "#8b8fa8", bg: "rgba(139,143,168,0.1)", border: "rgba(139,143,168,0.3)" },
];

const BOLGELER = [
  { id: "sehir", label: "Bulunduğum Şehir", aciklama: "Sadece kendi şehrindeki kullanıcılara ulaş", ikon: "ri-building-2-line" },
  { id: "yakin", label: "Yakın Çevre", aciklama: "Şehrin ve çevre ilçelerdeki kullanıcıları hedefle", ikon: "ri-map-2-line" },
  { id: "turkiye", label: "Tüm Türkiye", aciklama: "Türkiye genelindeki tüm kullanıcılara ulaş", ikon: "ri-earth-line" },
];

interface Secimler { amac: string; kampanya: string; reklamTuru: string; butce: string; ozelButce: string; bolge: string; yas: [number, number]; cinsiyet: string; }

export default function ReklamOlustur() {
  const [aktifAdim, setAktifAdim] = useState(1);
  const [tamamlandi, setTamamlandi] = useState(false);
  const [detayliAcik, setDetayliAcik] = useState(false);
  const [secimler, setSecimler] = useState<Secimler>({ amac: "", kampanya: "", reklamTuru: "", butce: "", ozelButce: "", bolge: "", yas: [25, 45], cinsiyet: "hepsi" });

  const adimTamamMi = () => {
    switch (aktifAdim) {
      case 1: return !!secimler.amac;
      case 2: return !!secimler.kampanya;
      case 3: return !!secimler.reklamTuru;
      case 4: return !!secimler.butce && (secimler.butce !== "ozel" || !!secimler.ozelButce);
      case 5: return !!secimler.bolge;
      default: return true;
    }
  };

  const secilenKampanya = KAMPANYALAR.find((k) => k.id === secimler.kampanya);
  const secilenAmac = AMACLAR.find((a) => a.id === secimler.amac);
  const secilenReklamTuru = REKLAM_TURLERI.find((r) => r.id === secimler.reklamTuru);
  const secilenButce = BUTCELER.find((b) => b.id === secimler.butce);
  const secilenBolge = BOLGELER.find((b) => b.id === secimler.bolge);
  const butceLabel = secimler.butce === "ozel" && secimler.ozelButce ? `${Number(secimler.ozelButce).toLocaleString("tr-TR")} TL` : secilenButce?.label || "";

  if (tamamlandi) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] animate-fadeIn">
        <div className="rounded-2xl p-12 max-w-lg w-full text-center" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: "rgba(16,185,129,0.15)" }}>
            <i className="ri-checkbox-circle-fill text-4xl" style={{ color: "#10b981" }}></i>
          </div>
          <h2 className="text-2xl font-bold mb-3" style={{ color: TEXT_PRIMARY }}>Reklam Talebiniz Alındı!</h2>
          <p className="text-base leading-relaxed mb-8" style={{ color: TEXT_SECONDARY }}>Ekibimiz kısa sürede sizinle iletişime geçecektir.</p>
          <div className="rounded-xl p-4 text-left mb-8 space-y-2" style={{ backgroundColor: "#0d0f16" }}>
            {[
              { label: "Kampanya", val: secilenKampanya?.ad },
              { label: "Reklam Türü", val: secilenReklamTuru?.baslik },
              { label: "Bütçe", val: butceLabel },
              { label: "Hedef Bölge", val: secilenBolge?.label },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-sm" style={{ color: "#8b8fa8" }}>
                <i className="ri-checkbox-circle-line" style={{ color: "#10b981" }}></i>
                <span>{item.label}: <strong style={{ color: TEXT_PRIMARY }}>{item.val}</strong></span>
              </div>
            ))}
          </div>
          <button onClick={() => { setTamamlandi(false); setAktifAdim(1); setSecimler({ amac: "", kampanya: "", reklamTuru: "", butce: "", ozelButce: "", bolge: "", yas: [25, 45], cinsiyet: "hepsi" }); }}
            className="w-full py-3 rounded-xl text-white font-semibold text-sm cursor-pointer whitespace-nowrap transition-colors"
            style={{ background: "linear-gradient(135deg,#7c3aed,#4f46e5)" }}>
            Yeni Reklam Oluştur
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="mb-8">
        <h1 className="text-2xl font-bold" style={{ color: TEXT_PRIMARY }}>Reklam Oluştur</h1>
        <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Adım adım rehberli reklam oluşturma sistemi</p>
      </div>

      {/* Progress */}
      <div className="rounded-2xl p-6 mb-6" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <div className="flex items-center justify-between relative">
          <div className="absolute top-5 left-0 right-0 h-0.5 z-0" style={{ backgroundColor: "#1e2130" }} />
          <div className="absolute top-5 left-0 h-0.5 z-0 transition-all duration-700" style={{ width: `${((aktifAdim - 1) / (ADIMLAR.length - 1)) * 100}%`, background: "linear-gradient(to right,#7c3aed,#10b981)" }} />
          {ADIMLAR.map((adim) => {
            const gecildi = aktifAdim > adim.no;
            const aktif = aktifAdim === adim.no;
            return (
              <div key={adim.no} className="flex flex-col items-center gap-2 z-10">
                <div className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{ backgroundColor: gecildi ? "#10b981" : aktif ? "#7c3aed" : "#1e2130", border: aktif ? "3px solid rgba(124,58,237,0.3)" : "none", color: gecildi || aktif ? "white" : TEXT_SECONDARY }}>
                  {gecildi ? <i className="ri-check-line text-base"></i> : <i className={`${adim.ikon} text-base`}></i>}
                </div>
                <span className="text-xs font-medium whitespace-nowrap hidden sm:block" style={{ color: aktif ? "#a78bfa" : gecildi ? "#10b981" : TEXT_SECONDARY }}>{adim.baslik}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div key={aktifAdim} className="animate-fadeIn">
        {/* ADIM 1 */}
        {aktifAdim === 1 && (
          <div>
            <h2 className="text-xl font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Kampanya Amacını Seç</h2>
            <p className="text-sm mb-6" style={{ color: TEXT_SECONDARY }}>Reklamınla ne elde etmek istiyorsun?</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {AMACLAR.map((amac) => {
                const secili = secimler.amac === amac.id;
                return (
                  <button key={amac.id} onClick={() => setSecimler((p) => ({ ...p, amac: amac.id }))}
                    className="relative text-left p-6 rounded-2xl transition-all duration-200 cursor-pointer"
                    style={{ backgroundColor: secili ? `${amac.accent}15` : CARD_BG, border: `2px solid ${secili ? amac.accent : BORDER}` }}>
                    {secili && <div className="absolute top-4 right-4 w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: amac.accent }}><i className="ri-check-line text-white text-xs"></i></div>}
                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${amac.renk} flex items-center justify-center mb-4`}>
                      <i className={`${amac.ikon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-base font-bold mb-1" style={{ color: TEXT_PRIMARY }}>{amac.baslik}</h3>
                    <p className="text-sm leading-relaxed" style={{ color: TEXT_SECONDARY }}>{amac.aciklama}</p>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* ADIM 2 */}
        {aktifAdim === 2 && (
          <div>
            <h2 className="text-xl font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Kampanyanı Seç</h2>
            <p className="text-sm mb-6" style={{ color: TEXT_SECONDARY }}>Hangi kampanyanı tanıtmak istiyorsun?</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {KAMPANYALAR.map((kamp) => {
                const secili = secimler.kampanya === kamp.id;
                return (
                  <div key={kamp.id} className="rounded-2xl overflow-hidden cursor-pointer transition-all duration-200"
                    style={{ border: `2px solid ${secili ? "#7c3aed" : BORDER}`, backgroundColor: CARD_BG }}
                    onClick={() => setSecimler((p) => ({ ...p, kampanya: kamp.id }))}>
                    <div className="relative">
                      <img src={kamp.gorsel} alt={kamp.ad} className="w-full h-40 object-cover object-top" />
                      <span className="absolute top-3 left-3 text-xs font-semibold px-2.5 py-1 rounded-full" style={kamp.etiketRenk}>{kamp.etiket}</span>
                      {secili && <div className="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center" style={{ backgroundColor: "#7c3aed" }}><i className="ri-check-line text-white text-sm"></i></div>}
                    </div>
                    <div className="p-4">
                      <h3 className="text-sm font-bold mb-1" style={{ color: TEXT_PRIMARY }}>{kamp.ad}</h3>
                      <p className="text-xs mb-3 leading-relaxed" style={{ color: TEXT_SECONDARY }}>{kamp.aciklama}</p>
                      <button className="w-full py-2 rounded-lg text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap"
                        style={{ backgroundColor: secili ? "#7c3aed" : "#1e2130", color: secili ? "white" : TEXT_SECONDARY }}>
                        {secili ? "Seçildi" : "Bu Kampanyayı Seç"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ADIM 3 */}
        {aktifAdim === 3 && (
          <div>
            <h2 className="text-xl font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Reklam Türünü Belirle</h2>
            <p className="text-sm mb-6" style={{ color: TEXT_SECONDARY }}>Hangi reklam formatı hedefine en uygun?</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {REKLAM_TURLERI.map((tur) => {
                const secili = secimler.reklamTuru === tur.id;
                return (
                  <button key={tur.id} onClick={() => setSecimler((p) => ({ ...p, reklamTuru: tur.id }))}
                    className="relative text-left p-5 rounded-2xl transition-all duration-200 cursor-pointer"
                    style={{ backgroundColor: secili ? tur.bg : CARD_BG, border: `2px solid ${secili ? tur.border : BORDER}` }}>
                    {tur.etiket && <span className="absolute top-4 right-4 text-xs font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: "rgba(16,185,129,0.15)", color: "#10b981" }}>{tur.etiket}</span>}
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: tur.bg }}>
                      <i className={`${tur.ikon} text-2xl`} style={{ color: tur.accent }}></i>
                    </div>
                    <h3 className="text-sm font-bold mb-1" style={{ color: TEXT_PRIMARY }}>{tur.baslik}</h3>
                    <p className="text-xs leading-relaxed" style={{ color: TEXT_SECONDARY }}>{tur.aciklama}</p>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* ADIM 4 */}
        {aktifAdim === 4 && (
          <div>
            <h2 className="text-xl font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Bütçeni Ayarla</h2>
            <p className="text-sm mb-6" style={{ color: TEXT_SECONDARY }}>Reklam için ayırmak istediğin bütçeyi seç</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
              {BUTCELER.map((b) => {
                const secili = secimler.butce === b.id;
                return (
                  <button key={b.id} onClick={() => setSecimler((p) => ({ ...p, butce: b.id }))}
                    className="text-center p-5 rounded-2xl transition-all duration-200 cursor-pointer"
                    style={{ backgroundColor: secili ? b.bg : CARD_BG, border: `2px solid ${secili ? b.border : BORDER}` }}>
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-3" style={{ backgroundColor: b.bg }}>
                      <i className={`${b.ikon} text-xl`} style={{ color: b.accent }}></i>
                    </div>
                    <p className="text-base font-bold" style={{ color: TEXT_PRIMARY }}>{b.label}</p>
                    <p className="text-xs mt-1" style={{ color: TEXT_SECONDARY }}>{b.aciklama}</p>
                  </button>
                );
              })}
            </div>
            <div className="rounded-2xl p-6 mb-4" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>Bütçe Aralığı</span>
                <span className="text-sm font-bold" style={{ color: "#a78bfa" }}>{butceLabel || "Seçilmedi"}</span>
              </div>
              <input type="range" min={1000} max={50000} step={500}
                value={secimler.butce === "ozel" && secimler.ozelButce ? Number(secimler.ozelButce) : secimler.butce === "3000" ? 3000 : secimler.butce === "5000" ? 5000 : secimler.butce === "10000" ? 10000 : 5000}
                onChange={(e) => setSecimler((p) => ({ ...p, butce: "ozel", ozelButce: e.target.value }))}
                className="w-full h-2 rounded-full appearance-none cursor-pointer"
                style={{ background: `linear-gradient(to right, #7c3aed ${(((secimler.butce === "ozel" && secimler.ozelButce ? Number(secimler.ozelButce) : 5000) - 1000) / 49000) * 100}%, #1e2130 ${(((secimler.butce === "ozel" && secimler.ozelButce ? Number(secimler.ozelButce) : 5000) - 1000) / 49000) * 100}%)` }} />
              <div className="flex justify-between text-xs mt-2" style={{ color: TEXT_SECONDARY }}><span>1.000 TL</span><span>50.000 TL</span></div>
            </div>
            {secimler.butce === "ozel" && (
              <div className="rounded-2xl p-5 mb-4" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
                <label className="text-sm font-semibold block mb-2" style={{ color: TEXT_PRIMARY }}>Özel Bütçe Miktarı (TL)</label>
                <input type="number" placeholder="Örn: 7500" value={secimler.ozelButce} onChange={(e) => setSecimler((p) => ({ ...p, ozelButce: e.target.value }))}
                  className="w-full rounded-xl px-4 py-3 text-sm outline-none transition-colors"
                  style={{ backgroundColor: "#0d0f16", border: `1px solid ${BORDER}`, color: "#c8cad8" }} />
              </div>
            )}
            <p className="text-xs flex items-center gap-1.5" style={{ color: "#f59e0b" }}><i className="ri-information-line"></i>Reklam yönetimi ve optimizasyon hizmeti ek ücrete tabidir.</p>
          </div>
        )}

        {/* ADIM 5 */}
        {aktifAdim === 5 && (
          <div>
            <h2 className="text-xl font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Hedef Bölgeyi Seç</h2>
            <p className="text-sm mb-6" style={{ color: TEXT_SECONDARY }}>Reklamın kimlere gösterilsin?</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              {BOLGELER.map((bolge) => {
                const secili = secimler.bolge === bolge.id;
                return (
                  <button key={bolge.id} onClick={() => setSecimler((p) => ({ ...p, bolge: bolge.id }))}
                    className="text-left p-6 rounded-2xl transition-all duration-200 cursor-pointer"
                    style={{ backgroundColor: secili ? "rgba(124,58,237,0.1)" : CARD_BG, border: `2px solid ${secili ? "#7c3aed" : BORDER}` }}>
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: secili ? "rgba(124,58,237,0.15)" : "#1e2130" }}>
                      <i className={`${bolge.ikon} text-2xl`} style={{ color: secili ? "#a78bfa" : TEXT_SECONDARY }}></i>
                    </div>
                    <h3 className="text-sm font-bold mb-1" style={{ color: secili ? "#a78bfa" : TEXT_PRIMARY }}>{bolge.label}</h3>
                    <p className="text-xs leading-relaxed" style={{ color: TEXT_SECONDARY }}>{bolge.aciklama}</p>
                  </button>
                );
              })}
            </div>
            <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
              <button onClick={() => setDetayliAcik(!detayliAcik)} className="w-full flex items-center justify-between p-5 cursor-pointer transition-colors"
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.03)")} onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(124,58,237,0.15)" }}>
                    <i className="ri-filter-3-line text-sm" style={{ color: "#a78bfa" }}></i>
                  </div>
                  <div className="text-left">
                    <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>Detaylı Hedefleme</p>
                    <p className="text-xs" style={{ color: TEXT_SECONDARY }}>Yaş, cinsiyet ve ilgi alanı filtrele</p>
                  </div>
                </div>
                <i className={`${detayliAcik ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg`} style={{ color: TEXT_SECONDARY }}></i>
              </button>
              {detayliAcik && (
                <div className="px-5 pb-5 animate-fadeIn" style={{ borderTop: `1px solid ${BORDER}` }}>
                  <div className="mt-4 space-y-5">
                    <div>
                      <div className="flex justify-between mb-2">
                        <label className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>Yaş Aralığı</label>
                        <span className="text-sm font-bold" style={{ color: "#a78bfa" }}>{secimler.yas[0]} – {secimler.yas[1]}</span>
                      </div>
                      <div className="flex gap-3">
                        <input type="range" min={18} max={65} step={1} value={secimler.yas[0]} onChange={(e) => setSecimler((p) => ({ ...p, yas: [Number(e.target.value), p.yas[1]] }))} className="w-full h-2 rounded-full appearance-none cursor-pointer" style={{ accentColor: "#7c3aed" }} />
                        <input type="range" min={18} max={65} step={1} value={secimler.yas[1]} onChange={(e) => setSecimler((p) => ({ ...p, yas: [p.yas[0], Number(e.target.value)] }))} className="w-full h-2 rounded-full appearance-none cursor-pointer" style={{ accentColor: "#7c3aed" }} />
                      </div>
                    </div>
                    <div>
                      <label className="text-sm font-semibold block mb-2" style={{ color: TEXT_PRIMARY }}>Cinsiyet</label>
                      <div className="flex gap-2">
                        {[{ id: "hepsi", label: "Hepsi" }, { id: "kadin", label: "Kadın" }, { id: "erkek", label: "Erkek" }].map((c) => (
                          <button key={c.id} onClick={() => setSecimler((p) => ({ ...p, cinsiyet: c.id }))}
                            className="px-4 py-2 rounded-lg text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap"
                            style={{ backgroundColor: secimler.cinsiyet === c.id ? "#7c3aed" : "#1e2130", color: secimler.cinsiyet === c.id ? "white" : TEXT_SECONDARY }}>
                            {c.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ADIM 6 */}
        {aktifAdim === 6 && (
          <div>
            <h2 className="text-xl font-bold mb-1" style={{ color: TEXT_PRIMARY }}>Onayla ve Gönder</h2>
            <p className="text-sm mb-6" style={{ color: TEXT_SECONDARY }}>Reklam detaylarını kontrol et ve talebi oluştur</p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="rounded-2xl p-6" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
                <h3 className="text-sm font-bold mb-5 flex items-center gap-2" style={{ color: TEXT_PRIMARY }}>
                  <i className="ri-file-list-3-line" style={{ color: "#a78bfa" }}></i>Reklam Özeti
                </h3>
                <div className="space-y-3">
                  {[
                    { ikon: "ri-focus-3-line", label: "Kampanya Amacı", val: secilenAmac?.baslik, accent: "#a78bfa", bg: "rgba(124,58,237,0.15)" },
                    { ikon: "ri-layout-grid-line", label: "Seçilen Kampanya", val: secilenKampanya?.ad, accent: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
                    { ikon: secilenReklamTuru?.ikon || "ri-advertisement-line", label: "Reklam Türü", val: secilenReklamTuru?.baslik, accent: "#ec4899", bg: "rgba(236,72,153,0.15)" },
                    { ikon: "ri-money-dollar-circle-line", label: "Bütçe", val: butceLabel, accent: "#10b981", bg: "rgba(16,185,129,0.15)" },
                    { ikon: "ri-map-pin-2-line", label: "Hedef Bölge", val: secilenBolge?.label, accent: "#38bdf8", bg: "rgba(56,189,248,0.15)" },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-4 p-3 rounded-xl" style={{ backgroundColor: "#0d0f16" }}>
                      <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: item.bg }}>
                        <i className={`${item.ikon} text-base`} style={{ color: item.accent }}></i>
                      </div>
                      <div>
                        <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
                        <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>{item.val || "—"}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="space-y-4">
                {secilenKampanya && (
                  <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
                    <img src={secilenKampanya.gorsel} alt={secilenKampanya.ad} className="w-full h-44 object-cover object-top" />
                    <div className="p-4">
                      <h4 className="text-sm font-bold" style={{ color: TEXT_PRIMARY }}>{secilenKampanya.ad}</h4>
                      <p className="text-xs mt-1" style={{ color: TEXT_SECONDARY }}>{secilenKampanya.aciklama}</p>
                    </div>
                  </div>
                )}
                <div className="rounded-xl p-4 flex items-start gap-3" style={{ backgroundColor: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)" }}>
                  <i className="ri-information-line text-lg flex-shrink-0 mt-0.5" style={{ color: "#f59e0b" }}></i>
                  <p className="text-xs leading-relaxed" style={{ color: "#fbbf24" }}>Reklam yönetimi ve optimizasyon hizmeti ek ücrete tabidir. Ekibimiz sizinle iletişime geçerek detayları paylaşacaktır.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Alt Nav */}
      <div className="flex items-center justify-between mt-8 pt-6" style={{ borderTop: `1px solid ${BORDER}` }}>
        <button onClick={() => aktifAdim > 1 && setAktifAdim((p) => p - 1)} disabled={aktifAdim === 1}
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
          style={{ color: aktifAdim === 1 ? "#2a2d3a" : TEXT_SECONDARY }}>
          <i className="ri-arrow-left-line"></i>Geri
        </button>
        <div className="flex items-center gap-2">
          {ADIMLAR.map((adim) => (
            <div key={adim.no} className="rounded-full transition-all duration-300"
              style={{ width: aktifAdim === adim.no ? 24 : 8, height: 8, backgroundColor: aktifAdim === adim.no ? "#7c3aed" : aktifAdim > adim.no ? "#10b981" : "#1e2130" }} />
          ))}
        </div>
        {aktifAdim < 6 ? (
          <button onClick={() => adimTamamMi() && setAktifAdim((p) => p + 1)} disabled={!adimTamamMi()}
            className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold transition-all cursor-pointer whitespace-nowrap text-white"
            style={{ background: adimTamamMi() ? "linear-gradient(135deg,#7c3aed,#4f46e5)" : "#1e2130", color: adimTamamMi() ? "white" : TEXT_SECONDARY }}>
            Devam Et<i className="ri-arrow-right-line"></i>
          </button>
        ) : (
          <button onClick={() => setTamamlandi(true)}
            className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap transition-colors"
            style={{ background: "linear-gradient(135deg,#10b981,#059669)" }}>
            <i className="ri-send-plane-line"></i>Reklam Talebi Oluştur
          </button>
        )}
      </div>
    </div>
  );
}
